<template>
  <v-row no-gutters justify="center" align="end" class="fill-height">
    <v-col cols="12" class="pb-1" v-if="!hover">
      <v-icon color="white" class="ml-6">mdi-plus</v-icon>
    </v-col>
    <v-col cols="12" v-if="hover">
      <v-tooltip right color="black" :nudge-right="8">
        <template #activator="{ on }">
          <v-btn
              icon
              large
              dark
              style="margin-left: 13px;"
              v-on="on"
              @click="openTool('timer')"
          >
            <v-icon>mdi-timer-sand</v-icon>
          </v-btn>
        </template>
        <div>Timer</div>
      </v-tooltip>
    </v-col>
    <v-col cols="12" v-if="hover">
      <v-tooltip right color="black" :nudge-right="8">
        <template #activator="{ on }">
          <v-btn
              icon
              large
              dark
              style="margin-left: 13px;"
              v-on="on"
              @click="openTool('stopwatch')"
          >
            <v-icon>mdi-timer-outline</v-icon>
          </v-btn>
        </template>
        <div>Stopwatch</div>
      </v-tooltip>
    </v-col>
    <v-col cols="12" class="pb-3" v-if="hover">
      <v-tooltip right color="black" :nudge-right="8">
        <template #activator="{ on }">
          <v-btn
              icon
              large
              dark
              style="margin-left: 13px;"
              v-on="on"
              @click="openTool('candidate_selector')"
          >
            <v-icon>mdi-account-search-outline</v-icon>
          </v-btn>
        </template>
        <div>Candidate Selector</div>
      </v-tooltip>
    </v-col>
  </v-row>
</template>

<script>
import EventHub from '@/events/hub';

export default {
  name: "GeneralToolsList",
  props: {
    hover: {
      type: Boolean,
      default: false,
    },
  },
  methods: {
    openTool(type = 'default') {
      EventHub.$emit('general.tools.type', type);
      EventHub.$emit('general.tools.open');
    },
  },
}
</script>

<style scoped>

</style>